<template>
  <div>
    <JsonEditorView v-model="val" v-bind="{...$props, ...$attrs}" @toggleFullscreen="toggleFullscreen"></JsonEditorView>

    <k-dialog v-model="fullscreen" fullscreen>
      <JsonEditorView v-model="val" :height="height" :readOnly="readOnly" :fullscreen="true" @toggleFullscreen="toggleFullscreen"></JsonEditorView>
    </k-dialog>
  </div>
</template>

<script>
import JsonEditorView from './JsonEditorView'

export default {
  components: {
    JsonEditorView
  },
  props: {
    value: {
      required: true
    },
    height: {
      type: Number,
      default: 400
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fullscreen: false
    }
  },
  methods: {
    toggleFullscreen(value) {
      this.fullscreen = value;
    }
  },
  computed: {
    val: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit("input", newVal);
      }
    },
  }
}
</script>

<style>

</style>